// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_py-0";